import { formatMessage } from "@flixbus-phx/marketplace-common";
import { BookingInformationField, PassengerInformationField, TripInformationField } from "../../../shared/types/schema";

export type BookingDataField = BookingInformationField | TripInformationField | PassengerInformationField;

const translationKeys = new Map<BookingDataField, string>([
  [BookingInformationField.FlixOrderId, "partnerForm.bookingInfo.bookingInformation.flixOrderId"],
  [BookingInformationField.PartnerOrderId, "partnerForm.bookingInfo.bookingInformation.partnerOrderId"],
  [BookingInformationField.BookingDate, "partnerForm.bookingInfo.bookingInformation.bookingDate"],
  [BookingInformationField.PaidPrice, "partnerForm.bookingInfo.bookingInformation.paidPrice"],
  [BookingInformationField.BoardingPass, "partnerForm.bookingInfo.bookingInformation.boardingPass"],
  [BookingInformationField.Invoice, "partnerForm.bookingInfo.bookingInformation.invoice"],

  [TripInformationField.LineCode, "partnerForm.bookingInfo.tripInformation.lineCode"],
  [TripInformationField.TravelDate, "general.travelDate"],
  [TripInformationField.DepartureTime, "partnerForm.bookingInfo.tripInformation.departureTime"],
  [TripInformationField.ArrivalTime, "partnerForm.bookingInfo.tripInformation.arrivalTime"],
  [
    TripInformationField.DepartureAndArrivalStation,
    "partnerForm.bookingInfo.tripInformation.departureAndArrivalStation",
  ],
  [TripInformationField.InterconnectionTrip, "partnerForm.bookingInfo.tripInformation.interconnectionTrip"],

  [PassengerInformationField.Name, "general.name"],
  [PassengerInformationField.Phone, "partnerForm.bookingInfo.passengerInformation.phone"],
  [PassengerInformationField.EMail, "general.email"],
  [PassengerInformationField.Nationality, "partnerForm.bookingInfo.passengerInformation.nationality"],
  [PassengerInformationField.Gender, "partnerForm.bookingInfo.passengerInformation.gender"],
  [PassengerInformationField.TicketType, "partnerForm.bookingInfo.passengerInformation.ticketType"],
  [PassengerInformationField.Birthday, "partnerForm.bookingInfo.passengerInformation.birthday"],
  [PassengerInformationField.IdentityDocument, "partnerForm.bookingInfo.passengerInformation.identityDocument"],
  [
    PassengerInformationField.IdentityDocumentNumber,
    "partnerForm.bookingInfo.passengerInformation.identityDocumentNumber",
  ],
  [PassengerInformationField.IdExpiryDate, "partnerForm.bookingInfo.passengerInformation.idExpiryDate"],
  [PassengerInformationField.IdIssuingCountry, "partnerForm.bookingInfo.passengerInformation.idIssuingCountry"],
  [PassengerInformationField.VisaDataProvided, "partnerForm.bookingInfo.passengerInformation.visaDataProvided"],
  [PassengerInformationField.VisaPermitType, "partnerForm.bookingInfo.passengerInformation.visaPermitType"],
  [PassengerInformationField.DiscountIdNumber, "partnerForm.bookingInfo.passengerInformation.discountIdNumber"],
  [PassengerInformationField.CheckInStatus, "partnerForm.bookingInfo.passengerInformation.checkInStatus"],
  [PassengerInformationField.SeatLabels, "partnerForm.bookingInfo.passengerInformation.seatLabels"],
  [PassengerInformationField.Luggage, "partnerForm.bookingInfo.passengerInformation.luggage"],
  [PassengerInformationField.Wheelchair, "partnerForm.bookingInfo.passengerInformation.wheelchair"],
  [PassengerInformationField.ResidenceCountry, "partnerForm.bookingInfo.passengerInformation.residenceCountry"],
  [PassengerInformationField.AddressCity, "partnerForm.bookingInfo.passengerInformation.addressCity"],
  [PassengerInformationField.AddressStreet, "partnerForm.bookingInfo.passengerInformation.addressStreet"],
  [PassengerInformationField.AddressState, "partnerForm.bookingInfo.passengerInformation.addressState"],
  [PassengerInformationField.AddressZipCode, "partnerForm.bookingInfo.passengerInformation.addressZipCode"],
]);

export const getLabelTextForBookingData = (field: BookingDataField): string => {
  return formatMessage(translationKeys.get(field) || "partnerForm.bookingInfo.unknownField");
};

export const isDefaultValue = (field: BookingDataField): boolean => {
  return [
    BookingInformationField.FlixOrderId,
    TripInformationField.LineCode,
    TripInformationField.TravelDate,
    TripInformationField.DepartureTime,
    TripInformationField.ArrivalTime,
    TripInformationField.DepartureAndArrivalStation,
    PassengerInformationField.Name,
  ].includes(field);
};
